var _defs, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductPlatinum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 125.66 45.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #939598;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.89,7.05c5.43,0,10.12,3.8,11.23,9.11,1.11,5.31-1.65,10.68-6.63,12.86-4.97,2.18-10.79.57-13.94-3.86-2.15,3.02-5.63,4.82-9.34,4.82-1.22,0-2.75-.33-3.58-.57-1.27-.36-2.49-1.17-3.15-1.64,4.51-.6,7.93-4.37,8.1-8.92,0-.11,0-.22,0-.34s0-.22,0-.34c-.17-4.55-3.6-8.32-8.11-8.92.96-.71,2.03-1.26,3.16-1.64.66-.22,2.36-.57,3.58-.57,3.71,0,7.19,1.8,9.33,4.82,2.15-3.02,5.63-4.82,9.34-4.82h0ZM55.14,24.57c2.05-1.33,3.29-3.6,3.29-6.05s-1.24-4.72-3.29-6.05c2.29,3.71,2.29,8.39,0,12.09ZM69.89,25.73c3.98,0,7.21-3.23,7.21-7.21s-3.23-7.21-7.21-7.21-7.21,3.23-7.21,7.21,3.23,7.21,7.21,7.21ZM69.89,15.33c1.76,0,3.19,1.43,3.19,3.19s-1.43,3.19-3.19,3.19-3.19-1.43-3.19-3.19,1.43-3.19,3.19-3.19Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.09,
    y: 39.4,
    width: 125.66,
    height: 6.34
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductPlatinum);
export default __webpack_public_path__ + "static/media/product-platinum.25aceeb848722f3b373ef8d59f582167.svg";
export { ForwardRef as ReactComponent };